import { XC_URL } from '../config';

export const makeQuery = (param) => {
	let p;
	let str = '';
	param || (param = {});
	for (p in param) {
		// when undefined is provided as a value do not include it in resulting query string
		if (param.hasOwnProperty(p) && param[p] !== undefined) {
			str += '&' + p + '=' + encodeURIComponent(param[p]);
		}
	}
	return str.length ? '?' + str.substr(1) : '';
};

/* always use without trailing slash because of MW requirements */
export const getHost = () => {
	let host = XC_URL;
	if (host.substr(-1) == '/') {
		host = host.substr(0, host.length - 1);
	}
	return host;
};

export const isChrome = () => {
	return navigator.userAgent.match(/Chrome\/(\S+)/);
};


// WEBPACK FOOTER //
// ./src/utils/browser.js